<script>
import axios from '@/services/axios';
import Vue from "vue";

export default {
  methods: {
    toSnakeCase: function (value) {
      if (!value) return '';
      return value.split(' ').map(function (item) {
        return item.toLowerCase()
      }).join('_');
    },
    isSuperagency() {
      return JSON.parse(this.$localStorage.get("isSuperagency"));
    },
    refreshSettings() {
      return axios.get('/agent/account/info').then((res) => {
        let ls = window.localStorage;
        let result = res.data;
        ls.setItem('role', result.data.role);
        ls.setItem('isConsumerOwner', result.data.is_consumer_owner);
        ls.setItem('email', result.data.email);
        ls.setItem('agency', result.data.agency);
        ls.setItem('agencyID', result.data.agency_id);
        window.location.href = '/';
        return true
      })
    },
    can(perm) {
      return Vue.$rbac && Vue.$rbac.indexOf(perm) > -1;
    },
    login() {
      if (Vue.prototype.$keycloak) {
        Vue.prototype.$keycloak.login();
      }
    },
    logout() {
      let ls = window.localStorage;
      ls.removeItem("logged");
      ls.removeItem("token");
      ls.removeItem("role");
      ls.removeItem("isConsumerOwner");
      ls.removeItem("email");
      ls.removeItem("agency");
      if (this.$keycloak) {
        let logoutUrl = this.$keycloak.endpoints.logout()
            + '?id_token_hint=' + this.$keycloak.idToken
            + '&post_logout_redirect_uri=' + encodeURIComponent(window.location.href);

        window.location.href = logoutUrl;
      }
    }
  }
}
</script>
